import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { DoubleBounce } from 'better-react-spinkit';
import Login from './Login';
export default function Register({ color }) {
  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  //Register details
  const [logState, setLogState] = useState(false);

  const initialState = {
    username: '',
    password: '',
    password2: '',
    email: '',
  };
  const [formdata, setFormdata] = useState(initialState);
  const onChange = (e) => {
    setFormdata({
      ...formdata,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLogState(true);
    const config = {
      headers: {
        'content-type': 'application/json',
      },
    };
    console.log(formdata);
  };

  return (
    <>
      <div className="">
        <button
          type="button"
          onClick={openModal}
          className={`px-2 inline-block pt-1 text-center text-lg font-medium text-${
            color ? color : 'white'
          }  rounded-md bg-opacity-20 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
        >
          Register
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="mt-2">
                  <div className="w-full sm:max-w-2xl sm:mx-auto max-h-full p-10 bg-gray-100 rounded-lg">
                    <h1 className="text-4xl font-bold tracking-widest text-blue-900 text-center">
                      Register
                    </h1>
                    <div className=" items-center justify-center">
                      <form
                        onSubmit={onSubmit}
                        className="flex flex-col space-y-5 py-4"
                      >
                        <input
                          type="text"
                          placeholder="Username"
                          name="username"
                          value={formdata.username}
                          onChange={onChange}
                          className="px-10 py-2 outline-none focus:ring-1 ring-blue-400 rounded-md placeholder-gray-400"
                        />
                        <input
                          type="email"
                          placeholder="Email"
                          name="username"
                          value={formdata.Email}
                          onChange={onChange}
                          className="px-10 py-2 outline-none focus:ring-1 ring-blue-400 rounded-md placeholder-gray-400"
                        />
                        <input
                          type="password"
                          placeholder=" Password"
                          name="password"
                          value={formdata.password}
                          onChange={onChange}
                          className="px-10 mb-8 py-2 outline-none focus:ring-1 ring-blue-400 rounded-md placeholder-gray-400"
                        />
                        <input
                          type="password"
                          placeholder="Confirm Password"
                          name="password"
                          value={formdata.password2}
                          onChange={onChange}
                          className="px-10 mb-8 py-2 outline-none focus:ring-1 ring-blue-400 rounded-md placeholder-gray-400"
                        />
                        {logState ? (
                          <div className="justify-center items-center flex mx-auto max-w-4xl">
                            <DoubleBounce size={50} color="blue" />
                          </div>
                        ) : (
                          ''
                        )}
                        <button
                          // onClick={() => setLogState(true)}
                          type="submit"
                          className="mt-8 px-8 py-2 text-lg text-white bg-green-700 rounded-lg hover:bg-green-500 active:bg-green-300 focus:ring-1 ring-green-300"
                        >
                          Register
                        </button>
                        <span className="">
                          Already Have an account? <Login color="blue-400" />
                        </span>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
